import {fetchRemote} from "./api-util";

import securityApi from "../Util/security";

const apiEndpoint = '/api/MediaLibrary/';
const controllerEndpoint = '/MediaLibrary/';

const defaultError = ['An unknown error occurred'];

function setFolderReferences(folder) {
    //Fix all cyclic references
    //for obvious reasons they can't be included during serialization
    if(folder.subFolders){
        folder.subFolders.forEach(function(subFolder){
            subFolder.parent = folder;
            setFolderReferences(subFolder);
        });
    }

    if(folder.files){
        folder.files.forEach(function(file){
            setFileReferences(file, folder);
        });
    }
}

function setFileReferences(file, folder) {
    //Fix all cyclic references
    //for obvious reasons they can't be included during serialization
    if(file.children){
        file.children.forEach(function(child){
            child.parent = file;
            child.folder = folder;
            
            setFileReferences(child, folder);
        });
    }
    
    file.folder = folder;
}

function fetchController(endpoint, opts){
    return fetchRemote(controllerEndpoint + endpoint, opts || {});
}

function fetchApi(endpoint, opts) {
    return fetchRemote(apiEndpoint + endpoint, opts || {});
}

export default {
    getCurrentLibrary () {
        return new Promise((resolve, reject) => {
            fetchApi('Library').then((response) => {
                response.json().then((data) => {
                    if(!data.success){
                        reject(data.errors || defaultError);
                        return;
                    }

                    const value = data.value;

                    //Fix our references
                    setFolderReferences(value);
                    resolve(value);
                }, reject);
            }, reject);
        });
    },
    getFileInfo(id){
        const endpoint = `FileInfo/${id}`;
        
        return new Promise((resolve, reject) => {
            fetchController(endpoint).then(response => {
                response.json().then(data => {
                    if(!data.success){
                        reject(data.errors || defaultError);
                        return;
                    }
                    
                    resolve(data.value);
                }, reject);
            }, reject);
        });
    },
    createFile(data) {
        const form = new FormData();
        const endpoint = 'CreateFile/?folderId=' + data.folderId;
        const opts = {
            method: 'POST',
            body: form
        };

        form.append('file', data.file);

        return new Promise((resolve, reject) => {
            fetchController(endpoint, opts).then((response) => {
                response.json().then((data) => {
                    if(!data.success){
                        reject(data.errors || defaultError);
                        return;
                    }

                    resolve(data.value);
                }, reject);
            }, reject);
        });
    },
    getImageEditConfiguration(id){
        const endpoint = 'Crop/' + id;
        
        return new Promise((resolve, reject) => {
            fetchController(endpoint).then(response => {
                response.json().then((data) => {
                    if(!data.success){
                        reject(data.errors || defaultError);
                        return;
                    }
                    
                    resolve(data.value);
                }, reject);
            }, reject);
        });
    },
    editImage(id, data){
        const endpoint = 'Crop/' + id;
        const opts = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        };

        return new Promise((resolve, reject) => {
            fetchController(endpoint, opts).then((response) => {
                response.json().then((data) => {
                    if(!data.success){
                        reject(data.errors || defaultError);
                        return;
                    }

                    resolve(data.value);
                }, reject);
            }, reject);
        });
    },
    getPublicImageUrl(id){
        return `${controllerEndpoint}DownloadPublicFile/${id}`;
    },
    getImageUrl(id){
        return `${controllerEndpoint}DownloadFile/${id}`;
    },
    getRootImageUrl(id){
        return `${controllerEndpoint}DownloadRootFile/${id}`;
    },
    renameFile(data){
        const form = new FormData();
        const endpoint = 'RenameFile';
        const opts = {
            method: 'POST',
            body: form
        };

        form.append('Id', data.id);
        form.append('NewName', data.newName);

        return new Promise((resolve, reject) => {
            fetchController(endpoint, opts).then((response) => {
                response.json().then((data) => {
                    if(!data.success){
                        reject(data.errors || defaultError);
                        return;
                    }

                    resolve( { name: data.value.newName });
                }, reject);
            }, reject);
        });
    },
    deleteFile(id) {
        const endpoint = 'File/' + id;
        const opts = {
            method: 'DELETE'
        };

        return new Promise((resolve, reject) => {
            fetchController(endpoint, opts)
                .then((response) => {
                    response.json().then((data) => {
                        if(!data.success){
                            reject(data.errors || defaultError);
                            return;
                        }

                        resolve();
                    }, reject);
                }, reject);
        });
    },
    createFolder(data) {
        const form = new FormData();
        const endpoint = 'CreateFolder';
        const opts = {
            method: 'POST',
            body: form
        };

        form.append('parentId', data.parentId);
        form.append('Name', data.name);

        return new Promise((resolve, reject) => {
            fetchController(endpoint, opts).then((response) => {
                response.json().then((data) => {
                    if(!data.success){
                        reject(data.errors || defaultError);
                        return;
                    }

                    resolve(data.value);
                }, reject);
            }, reject);
        });
    },
    renameFolder(data) {
        const form = new FormData();
        const endpoint = 'RenameFolder';
        const opts = {
            method: 'POST',
            body: form
        };

        form.append('Id', data.id);
        form.append('newName', data.newName);

        return new Promise((resolve, reject) => {
            fetchController(endpoint, opts).then((response) => {
                response.json().then((data) => {
                    if(!data.success){
                        reject(data.errors || defaultError);
                        return;
                    }

                    resolve( { name: data.value.newName } );
                }, reject);
            }, reject);
        });
    },
    deleteFolder(id) {
        const endpoint = 'Folder/' + id;
        const opts = {
            method: 'DELETE'
        };

        return new Promise((resolve, reject) => {
            fetchController(endpoint, opts).then((response) => {
                response.json().then((data) => {
                    if(!data.success){
                        reject(data.errors || defaultError);
                        return;
                    }

                    resolve();
                });
            }, reject);
        });
    },
    validatePermission(grantType){
        const permissionId = securityApi.Permissions.MediaLibrary;

        return new Promise((resolve) => {
            securityApi.validatePermission(
                permissionId,
                grantType
            ).then(
                //The promise being resolved indicates success
                () => {
                    resolve(true);
                },
                () => {
                    resolve(false);
                }
            );
        });
    }
};
